import { graphql } from 'react-relay';

export const notice = graphql`
  query noticeQuery {
    notice {
      result
      contents
    }
  }
`;
